package com.nonopn.skywatcher.common.app.pages.profile

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.LocalApp
import eu.codlab.viewmodel.rememberViewModel
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import io.ktor.http.Url

@Composable
fun ProfileContent(
    modifier: Modifier
) {
    val cornerSide = 4.dp
    val appModel = LocalApp.current
    val appModelState by appModel.states.collectAsState()
    val isSystemDarkMode = appModelState.isSystemDarkMode

    val model = rememberViewModel {
        ProfileContentModel(
            isSystemDarkMode,
            appModelState.currentApi!!
        )
    }
    val state by model.states.collectAsState()

    LaunchedEffect(isSystemDarkMode) {
        model.updateSystemDarkMode(isSystemDarkMode)
    }

    if (state.isLoading) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CircularProgressIndicator(Modifier.size(25.dp))
        }

        return
    }

    Column(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        state.profile?.let {
            KamelImage(
                modifier = Modifier.size(200.dp),
                resource = asyncPainterResource(
                    data = Url("https://api.lpsmanager.io/qrcode?qrcode=${it.uuid}")
                ),
                contentScale = ContentScale.Crop,
                contentDescription = "",
                onLoading = {
                    // RenderLoading(modifier)
                },
                onFailure = {
                    // RenderLoading(modifier)
                }
            )
        }
        /*state.qrCodeImage?.let { data ->
            DefaultCard(
                modifier = Modifier.width(IntrinsicSize.Min)
                    .height(IntrinsicSize.Min),
                columnModifier = Modifier.padding(12.dp),
                elevation = 10.dp,
                backgroundColor = defaultCardBackground(),
            ) {
                Image(
                    modifier = Modifier.size(250.dp),
                    bitmap = data,
                    contentDescription = ""
                )
            }
        }*/
    }
}